export default "__VITE_ASSET__DCuZ2TfS__"